import { Component, OnInit, Input, SimpleChange } from '@angular/core';

interface opcionSelect {
  value: string;
  viewValue: string;
}

//Opciones radiobutton
const temp: string = "TEMPERATURA";
const hume: string = "HUMEDAD";
const calAire: string = "CALIDAD AIRE";
const lumi: string = "LUMINOSIDAD";
const ruido: string = "RUIDO";
const ocup:  string = "OCUPACIÓN";
const libre: string = "LIBRE";
const pir:   string = "PIR";
const acel:  string = "ACELERÓMETRO";

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})


export class SelectorComponent implements OnInit {


  
  data = {
    opcionesDatos:[
      { value: temp,    viewValue: temp },
      { value: hume,    viewValue: hume },
      { value: calAire, viewValue: calAire },
      { value: lumi,    viewValue: lumi },
      { value: ruido,   viewValue: ruido },
      { value: ocup,    viewValue: ocup },
    ],
    opcionesEventos:[
      { value: ocup,     viewValue: ocup },
      { value: libre,    viewValue: libre },
      { value: pir,      viewValue: pir },
      { value: acel,     viewValue: acel },
      { value: ruido,    viewValue: ruido },
      
    ],
    opcionesAlarmas:[
      { value: ocup,     viewValue: ocup },
      { value: libre,    viewValue: libre },
      { value: pir,      viewValue: pir },
    ]
  }

  selectOpcion: string;
  opciones: opcionSelect[] = [
    {value: "",  viewValue: ""}
  ];

  @Input() opcion:string;

  constructor() { }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChange): void {
    console.log('[SELECTOR]  value changed: ' + this.opcion);

    switch(this.opcion) { 
      case "DISPOSITIVO": { 
        //datos
        console.log('[SELECTOR]  dispositivo: ' + this.opcion);
        // this.opciones = this.data.opcionesDisp;

        break; 
     } 
      case "datos": { 
         //datos
         console.log('[SELECTOR]  opcion: ' + this.opcion);
         this.opciones = this.data.opcionesDatos;

         break; 
      } 
      case "eventos": { 
        //eventos
        console.log('[SELECTOR]  opcion: ' + this.opcion);
        this.opciones = this.data.opcionesEventos;

        break; 
     } 
     case "alarmas": { 
      //LIBRE
      console.log('[SELECTOR]  opcion: ' + this.opcion);
      this.opciones 
      this.opciones = this.data.opcionesAlarmas;
      console.log(this.opciones);
      break; 
   } 
      default: { 
        //statements; 
        break; 
      } 
    }
  }

  onOptionSelected() {
    console.log('[SELECTOR]  onOptionSelected: ' + this.selectOpcion);
    
  }

}
